export const isRefundedPayment = payment => {
  const amount = payment?.amount && typeof payment.amount === 'object'
    ? Number(payment.amount.amount_minor) / 100 : Number(payment?.amount);
  return String(payment?.status || '').toLowerCase() === 'refunded'
    || /refund/i.test(String(payment?.type || '')) || amount < 0;
};
